import { useContext } from "react";
import { ThemeProvider } from "@mui/material";
import { ToastContainer } from "react-toastify";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";

import Dashboard from "./dashboard";
import Certificate from "./certificate";
import AdminLogin from "./adminlogin";
import { createTheming } from "../utils/Theme";
import AuthLayout from "../layouts/AuthLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import SettingsContext from "../context/SettingsContext";
import HomePage from "./home";

function App() {
  const themeSeeting = useContext(SettingsContext);
  const theme = createTheming({
    theme: themeSeeting.settings.theme,
  });

  return (
    <ThemeProvider theme={theme}>
      <Router basename="/">
        <Routes>
          <Route path="/" element={<HomePage />} />

          <Route path="/download-certificate" element={<Certificate />} />

          <Route
            path="/admin-signin"
            element={
              <AuthLayout>
                <AdminLogin />
              </AuthLayout>
            }
          />

          <Route
            path="/admin-dashboard"
            element={
              <DashboardLayout>
                <Dashboard />
              </DashboardLayout>
            }
          />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>

        <ToastContainer position="top-right" />
      </Router>
    </ThemeProvider>
  );
}

export default App;
